export default __webpack_public_path__ + "static/media/blinkit-logo.8fdcbd93.svg";